import {
  text,
  headline,
  spacer,
  image,
} from '@components/Widgets/_contentItems/all'
import themes from '@components/Widgets/Templates/Themes/all'
import { settings, styling } from '@components/Widgets/Templates/_base'
import { position, trigger, type } from '@meta/widget/options.js'
import { tag, typeTag } from '@meta/widget/templates'

const info = {
  name: 'Special Offer',
  templateID: '1',
  description: 'Highlight special promotions with the "Special Offer" widget. This widget allows you to showcase exclusive deals and discounts without requiring a promo code, making it straightforward for users to take advantage of the offer.',
  tags: [typeTag.FLYOUT, tag.COUPONS_OFFERS, tag.ANNOUNCEMENT],
}

const json = {
  id: 3424574,
  templateID: info.templateID,
  type: type.COLUMN,
  name: info.name,
  theme: themes.MONOCHROME,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.trigger = trigger.RIBBON
    customSettings.position = position.CENTER
    customSettings.animation = 'slide'
    customSettings.ribbonColor = 'rgba(254, 254, 254, 1)'
    customSettings.closeButtonColor = 'rgb(126, 83, 38)'
    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling } // Ensure we're working with a copy of the styling

    return customStyling
  })(),
  steps: [
    {
      id: 'yqkqdyg',
      contentItems: [
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/leather_gift.webp'
          Object.assign(customImage.styling,
            { backgroundColor: 'rgb(230, 232, 229)' })
          return customImage
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Special Offer!'
          Object.assign(customHeadline.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '26px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '8px' })
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'GET A LEATHER CASE FOR FREE'
          Object.assign(customHeadline.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '26px',
            textAlign: 'center',
            fontFamily: 'Roboto Slab',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'A promotional leather case is gifted automatically with every watch order.'
          Object.assign(customText.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '16px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '12px' })
          return customSpacer
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '* no need to enter promo code'
          Object.assign(customText.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '12px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
      ],
    },
  ],
}

export { json, info }
